import { render, staticRenderFns } from "./chevronIcon.vue?vue&type=template&id=9ed4080c&scoped=true&"
import script from "./chevronIcon.vue?vue&type=script&lang=js&"
export * from "./chevronIcon.vue?vue&type=script&lang=js&"
import style0 from "./chevronIcon.vue?vue&type=style&index=0&id=9ed4080c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed4080c",
  null
  
)

export default component.exports